import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {ChatInfoModel} from "../models/chat-info.model";
import {ChatUserModel} from "../models/chat-user.model";
import {BringozChatConversationModel} from "../models/chat-conversation.model";

@Injectable({providedIn: 'root'})
export class ChatHttpService {

  private base_url = `/chat`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getChatInfo(): Observable<ChatInfoModel> {
    return this.http
      .get<ChatInfoModel>(this.base_url)
      .pipe(map((c) => c));
    //FIXME: Mock
    // return of({
    //   token: 'eyJjdHkiOiJ0d2lsaW8tZnBhO3Y9MSIsInR5cCI6IkpXVCIsImFsZyI6IkhTMjU2In0.eyJpc3MiOiJTSzdkOTAxMzg2OGNlOWJiNDU2ZjkyNDU1YmFjNDRkNDE4IiwiZXhwIjoxNzAwNTAxNDMzLCJncmFudHMiOnsiaWRlbnRpdHkiOiJ1c2VyQGV4YW1wbGUuY29tIiwiY2hhdCI6eyJzZXJ2aWNlX3NpZCI6IklTODE4NDg1NjgxMThiNGQxODg0ODkyYmRhMTJkZGZiYzgifX0sImp0aSI6IlNLN2Q5MDEzODY4Y2U5YmI0NTZmOTI0NTViYWM0NGQ0MTgtMTcwMDQ5Nzc5MiIsInN1YiI6IkFDNWRkYTUwNTA1ZmViODBhMmU0MTY1NzkxYWZlMGY4NTgifQ.Qh_qiludhAJqkuT4IkBqygUMjvJN2I1y3J54VMlWL1A'
    // });
  }

  getUsers(siteId: string, query: string): Observable<ChatUserModel[]> {
    return this.http
      .get(`${this.base_url}/participant`, {params: {query: query, siteId: siteId}})
      .pipe(map((users) => {
        return users as ChatUserModel[];
      }));
  }

  createConversation(siteId: string, chatConversation: BringozChatConversationModel): Observable<BringozChatConversationModel> {
    return this.http
      .put(`${this.base_url}/conversation`, chatConversation, {params: {siteId: siteId}})
      .pipe(map((conversation: BringozChatConversationModel) => {
        return conversation;
      }));
  }

  updateConversation(siteId: string, conversationId: string, chatConversation: BringozChatConversationModel): Observable<BringozChatConversationModel> {
    return this.http
      .post(`${this.base_url}/conversation/${conversationId}`, chatConversation, {params: {siteId: siteId}})
      .pipe(map((conversation: BringozChatConversationModel) => {
        return conversation;
      }));
  }


  muteConversationUsers(siteId: string, conversationId: string, muteIds?: string[], unmuteIds?: string[], assignAdmin?: boolean): Observable<BringozChatConversationModel> {
    return this.http
      .post(`${this.base_url}/conversation/${conversationId}/notification`, {}, {params: {siteId: siteId, muteId: muteIds, unmuteId: unmuteIds, assignAdmin: assignAdmin}})
      .pipe(map((conversation: BringozChatConversationModel) => {
        return conversation;
      }));
  }

}
